module.exports = __webpack_public_path__ + "static/size_img_2-d1cd9230770ddfb8767abe0db92a7c6d.png";